export const videoEventNameToBehavior = new Map([
  ["contentstart", 240],
  ["pause", 241],
  ["resume", 242],
  ["timeupdate", 243],
  ["seek", 244],
  ["contentcomplete", 245],
  ["mute", 248],
  ["unmute", 249],
  ["fullscreenenter", 250],
  ["fullscreenexit", 251],
  ["replay", 252],
  ["ready", 253],
  ["closedcaptionschanged", 257], // unable to know the values that were changed to since this is in an iframe and message payload doesn't contain data
  ["closedcaptionsettingschanged", 258],
  ["videoqualitychanged", 259],
]);
